/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React, { ReactElement } from "react";

import { useAuth } from "Authentication/AuthProvider";
import SideNavigation from "Components/SideNavigation/SideNavigation";
import { getSideNavigationLinksForUser } from "Constants/SideNavigationLinks";
import { useGetBenefitsQuery } from "Services/BenefitManagementApi";

const SideNavigationContainer = (): ReactElement => {
  const { roles, hasAnyRoles } = useAuth();
  const { data, isError, isLoading } = useGetBenefitsQuery({});
  return hasAnyRoles ? (
    <SideNavigation
      links={getSideNavigationLinksForUser(roles, {
        hasError: isError,
        loading: isLoading,
        data: data,
      })}
    />
  ) : (
    <></>
  );
};

export default SideNavigationContainer;
